'use client';

import { FooterCommonLink } from '@cat-ecom/pcc-components';
import { useAssociatedDealer } from 'components/associated-dealers/associated-dealer-context';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';
import { FC, PropsWithChildren } from 'react';
type FindYourDealerLinkClientProps = {
  label: string;
  isLoggedIn: boolean;
  isFooterDesigneUpdate?: boolean;
  children?: React.ReactNode;
};

export const FindYourDealerLinkClient: FC<
  PropsWithChildren<FindYourDealerLinkClientProps>
> = ({ label, isLoggedIn, isFooterDesigneUpdate, children }) => {
  const dealerLocatorDrawer = useDealerLocatorDrawer();
  const { associatedDealerDrawer } = useAssociatedDealer();

  const drawerProps = isLoggedIn
    ? associatedDealerDrawer.initiatorProps
    : dealerLocatorDrawer.initiatorProps;

  return (
    <>
      <li>
        <FooterCommonLink
          isMobile={isFooterDesigneUpdate}
          label={label}
          {...drawerProps}
        />
      </li>
      {children}
    </>
  );
};
